import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArchive16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArchive16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 5V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1zm13 1h-1v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2zM3 6h10v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm3.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArchive16);
